<template>
  <div id="thsq">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'thsq'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/exit/apply/Apply.vue